<template>
    <div :id="name" class="overlay fixed flex justify-center items-center text-left" :class="{ 'visible': shown }" role="dialog" :aria-labelledby="name">
        <a href="#/" :class="[{'hidden': close == false}, 'cancel absolute']" aria-label="Close" @click="closeModal()"></a>

        <div class="modal">
            <div class="border-white overflow-hidden modal__inner">
                <slot></slot>

                <footer class="flex modal__footer">
                    <slot name="footer"></slot>
                </footer>
            </div>

            <a href="#/" :class="[{'hidden': close == false}, 'close absolute md:border-4 md:border-white']" aria-label="Close" @click="closeModal()">&times;</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        youtube: {
            type: String,
            required: false,
            default: 'false',
        },
        visible: {
            type: Boolean,
            required: false,
            default: false,
        },
        close: {
            type: Boolean,
            required: false,
            default: true,
        }
    },
    data() {
        return {
            youtubeEmbed: this.youtube,
            shown: this.visible
        }
    },
    methods: {
        closeModal() {
            if (this.youtubeEmbed === 'true') {
                stopYoutube() // Referenced as global javascript function in components/scripts.blade.php to stop youtube iframe from playing.
            }

            this.shown = false
        }
    },
}
</script>

<style lang="scss" scoped>
    .overlay {
        visibility: hidden;
        overflow-x: hidden;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, .7);
        transition: opacity .3s;
        opacity: 0;
        z-index: 999;

        &:target,
        &.visible {
            visibility: visible;
            opacity: 1;
        }

        .cancel {
            width: 100%;
            height: 100%;
        }
    }

    .modal {
        position: relative;
        width: 800px;
        max-width: 80%;
        max-height: 90%;
        background: #ffffff;
        box-shadow: 0 5px 11px rgba(36, 37, 38, 0.08);
        border-radius: 21px;

        > div {
            border-width: 5px;
            border-radius: 21px;
        }

        .close {
            top: -51px;
            right: 0;
            width: 47px;
            height: 47px;
            font-size: 41px;
            line-height: 31px;
            color: #ffffff;
            border-radius: 50%;
            text-align: center;
            text-decoration: none;

            @screen md {
                right: -62px;
            }
        }
    }
</style>
